var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper"},[_c('GmapMap',{ref:"mapRef",staticClass:"map",attrs:{"center":{lat:48.8577392, lng:2.3365915},"zoom":16,"map-type-id":"terrain"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }